<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nUHUhd/tc-custom/9780830896318.jpg?1696870402383" alt="This image is the cover for the book Evangelical Postcolonial Conversations"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Evangelical Postcolonial Conversations
      </h1>
      <p class="bookDescription body article font2">
        <p>How can the church respond to issues of imperialism, race and globalization? Constructing an evangelical postcolonial theology may be the solution to dealing with these ever-growing issues. Gathering together essays presented at the 2010 Postcolonial Roundtable at Gordon College, this groundbreaking volume seeks to reconcile the ugly history of cultural dominion and colonialism with new perspectives on global society. Rethinking and reimagining the concepts of identity, power, interpretation and historiography through the lens of Christianity, the editors provide readers with new ways of understanding and bettering the world. "The Christian faith of the future must be a joint enterprise in which the descendants of the colonized and the descendants of the colonizers come together, reflect on the past and imagine a different and better future together," contributor Brian McLaren states. "That work will involve risks and dangers for both groups, and the contributions of both are essential. One lesson the gospel surely teaches us is this: we are all connected." Addressing themes like nationalism, Christology and western conquest, contributors discuss reasons Christians need to be careful how they frame their conversations on global topics. The language of "mission" can be misconstrued in light of postcolonial perspectives, and the essays dig into the role of evangelicalism in modern Christian outreach to help us keep pace with what God is doing in our era.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kay Higuera Smith, Jayachitra Lalitha, L. Daniel Hawk
      </h2>
      
      <p class="authorDescription body article"><p>Kay Higuera Smith (Ph.D., Claremont Graduate University) is professor of religion and chair of the department of biblical studies at Azusa Pacific University. Her specialization is in the New Testament and early Judaism.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6c8accb5